/**
 *
 * Asynchronously loads the component for DigitalAssetManagementModule
 *
 */

import { lazyLoad } from 'utils/loadable';

export const DigitalAssetManagementModule = lazyLoad(
  () => import('./index'),
  module => module.DigitalAssetManagementModule,
);
